module.exports = __webpack_public_path__ + "static/map2-c235c39c175ec0327cda82850d36f716.png";